export const locale = {
  lang: 'zh1',
  data: {
    'LEADER_GO': {
      'SECCION_SELECT_LEADER':{
        'TEX_CARGA_INFO':'加載領導者',
        'TEX_FILT_INFO':'過濾領導',
        'TEX_TITL_TAB1':'選擇領導者',
        'TEX_TITL_TAB2':'預覽選定的領導者',
        'TEX_TITL_TAB2_1':'Líderes guardados',
        'TEX_INDIC_1':'*選擇要申請的領導者',
        'TEX_INDIC_BUSQ':'輸入姓名、電子郵件或地區',
        'TEX_BTN_FILT':'過濾器',
        'TH_1':'領導姓名',
        'TH_2':'郵件',
        'TH_3':'區域',
        'TH_4':'Genero',
        'TH_5':'Año',
        'TH_6':'Tipo de trabajo',
        'TH_7':'CGO用戶狀態',
        'TH_EMA_LOCA':'位置',
         'TH_EMA_SEND':'郵件已發送',
         'TH_PUEST_LEAD':'發布',
         'STATUS_LOGIN_CGO':{
         'false':'無效',
         'true':'積極的',
         'undefined':'無效',
         },
        'MODAL_ACTU_BAN_UNI':'添加選定的領導者',
        'MODAL_ACTU_BAN_MUL':'添加選定的領導者',
        'WARNI_NO_SELEC':'還不能完成該步驟，因為尚未選擇領導者',
        'COMFI_COMP_PAS':'你確定你已經完成了領導者選擇步驟嗎？',
        'BTN_CONFI_OK':'好的',
        'BTN_CONFI_YES':'是',
        'BTN_CONFI_NO':'否',
        'MODAL_CONFI_GUAR_LEA':'¿Está seguro de guardar los líderes seleccionados?',
        'BTN_GUAR_LEA':'Guardar líderes seleccionados',
        'BTN_ACT_LEA':'Actualizar líderes seleccionados',
        'MSN_INGR_COD':'<span>要發送邀請郵件，請在文本框中輸入紅色代碼',
         'MSN_INGR_COD2':'</span>',
         'MODAL_CONFI_SEND_MAIL':'你確定要發送郵件嗎？',
         'MODAL_CONFI_ACTIV_USER_CGO':'您確定要激活用戶嗎？',
         'MODAL_CONFI_DESACTIV_USER_CGO':'您確定要停用該用戶嗎？',
         'MSN_INGR_COD_ACTI_USER':'<span>要激活/停用用戶，請在文本框中輸入紅色代碼 ',
         'MODAL_ERR_COD':'放置的文字不匹配',
         'WARNI_NO_SELEC_LEA':'要能夠發送郵件，請至少選擇一位領導者',
         'BTN_SEND_MAIL':'發送郵件',
         'BTN_CONFI_CONFIRMAR':'確認',
         'BTN_CONFI_CANCELAR':'取消',
         'MOD_INFO_SEN_EMA':'正在發送電子郵件...',
         'SUCCE_SEN_EMA':'他們已正確發送',
         'NO_LEAD_PRODUCT_ASO':'此產品的相關證書不包含主要用戶。',
         'MOD_ACTI_USE_CGO': '實際使用狀態',
         'SUCCE_UPDA_STA_STA_USE': '更新成功',

      },
      'SECCION_PROGRAMACION':{
        'MODAL_CONFI_COMPL':'您確定已完成郵件編輯器步驟嗎？ ',
        'FECHAS':{
          'TITULO':'選擇日期',
         'BTN_TEXT':'選擇日期',
         'INSTRUC_TEXT':'選擇並註冊可配置的不同日期',
        },
        'CORREOS':{
          'TITULO':'通訊信息',
         'BTN_TEXT':'查看通訊信息',
         'INSTRUC_TEXT':'查看要發送的通訊信息',
          'TIPOS_CORREO':{
            'TIPO1_INVITA':{
              'TITULO': '邀請信息',
               'DESCRIP': '這是通話啟動當天發給領導的信息',
            },
            'TIPO2_RECOR_NO_INI':{
              'TITULO':'給尚未開始的領導人的信息',
                 'DESCRIP':'這是給還未發起的領導發送的提醒信息',
            },
            'TIPO3_RECOR_NO_FINA':{
              'TITULO':'給尚未完成的領導們的信息。',
               'DESCRIP':'這是發送給已經開始調查但尚未完成的領導的提醒信息',
            },
          }
        },
        'MODAL_ACCIO':{
          'TIPO_ACCIO_FECH':{
            'TITU_TEXT1':'選擇每個可用的日期進行配置',
          }
        },
        'ETIQ':{
          'tag_name':'領導者的名字',
           'tag_codeCoupon':'優惠券代碼',
           'tag_productoId':'產品編號',
           'tag_nameCourse':'課程名稱',
        }
      },
      'TIP_EMAI': {
        'lanzamiento': '邀請發布日期',
         'aviso1': '預發布（調查啟動前的第一個提示）',
         'aviso2': '預啟動（調查啟動前的第二個提示）',
         'cierre': '截止日期',
         'recordatorio1': '向尚未開始的人發送提醒的日期',
         'recordatorio2': '向未完成的人發送提醒的日期',
      },
      'SECCION_CONFIRM':{
        'BTN_CONFIRM_ENVIO':'確認郵寄',
        'BTN_ENVIO_CONFIRM':'已確認郵寄',
        'MODAL_COMPL_CONF':'您確定已完成郵寄確認步驟嗎？',
        'MODAL_WARNIN_CONF':'要完成此步驟，您必須確認郵件的發送。',
      },
      'SECCI_AVANCE':{
        'CARDS':{
          'PASO_1':{
            'TITULO':'進展',
           'DESCRIP':'領導進階',
           'BTN_1':'去計數傳送門',
           'BTN_2':'',
          },
          'PASO_2':{
            'TITULO':'提醒',
           'DESCRIP':'提醒尚未開始或完成流程的領導',
           'BTN_1':'提醒',
           'BTN_2':'',
          }
        }
      },
    },
    'ACTION_GO':{
      'COLUMNAS':{
          'NameUser':'姓名',
          'email':'郵件',
          'Area':'區域',
          'JobTitle':'郵政',
          'Localidad':'地點',
          'NumberOfEmails':'郵件已發送',
           'Age':'年',
           'Gneration':'性別',
           'IdUser':'用戶ID',
           'SurveyID':'調查ID',
           'keyUserlogin':'密碼',
           'Pass_cgo':'密碼',
      }
    }
  }
};
